import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            setChecking(false);
            return;
        }
        api
            .get("/admin/me")
            .then((res) => setAdmin(res.data))
            .catch(() => {
                localStorage.removeItem("admin_token");
                setAdmin(null);
            })
            .finally(() => setChecking(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/admin/login", { email, password });
        localStorage.setItem("admin_token", data.access_token);
        setAdmin({ email: data.email, role: "admin" });
        return data;
    };

    const logout = () => {
        localStorage.removeItem("admin_token");
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, checking, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
